<section class="section section--review-contract">
  <div class="container">
    <div class="wrapper">
      <div class="content fadeinright animation-duration-300">
        <form [formGroup]="form" class="form full__height">
          <div class="content__main flexColumn">
            <article class="mainInfo flexChild--static pb-20">
              <h1 class="pb-10">Firma del contrato</h1>
              <p>Por favor desplázate a través de la página para ir leyendo el <strong>contrato</strong>. Al final podrás realizar la <strong>firma digital</strong>.</p>
            </article>

            <article class="contractSignature flexChild--flexible scroller">
              <div class="loading-content" *ngIf="!agreementHTML">
                <div class="loading-indicator">
                  <p-progressSpinner></p-progressSpinner>
                </div>
                <div class="loading-text"><span>Cargando contrato...</span></div>
              </div>

              <div id="agreement-container" class="contractSignature__container p-scrollpanel overflow-y-auto overflow-x-hidden" *ngIf="agreementHTML" (scroll)="isTheEndOfAgreement()">
                <div class="contractSignature__content">
                  <div class="contractSignature__html">
                    <div class="html" [innerHTML]="agreementHTML | safeHtml"></div>
                  </div>

                  <div class="contractSignature__btn">
                    <button pButton pRipple type="button" label="Ir a firmar" icon="pi pi-angle-right" iconPos="right" class="p-button-primary p-button-raised p-button-rounded p-button-spaced w-full no-shadow" (click)="visibleSigningModal=true"></button>
                  </div>
                </div>
              </div>

              <!-- Animación de swipe comentada temporalmente
              <div class="swipeAnimation" [ngClass]="{ 'active': !isTheEndOfAgreement() }">
                <div class="swipeAnimation__text" *ngIf="agreementHTML">
                  <p class="md:hidden">Usa el dedo para moverte hacia abajo en el documento</p>
                  <p class="hidden md:block text-center">Para moverte hacía abajo usa el scroll de la derecha</p>
                </div>
                <div class="swipeAnimation__content md:hidden">
                  <div class="path"></div>
                  <div class="hand-icon">
                    <svg width="50" height="46" viewBox="0 0 50 46" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path class="svgStroke--primary" d="M45.9041 26.7683C48.0559 22.805 46.7944 17.9368 43.0895 15.9253L38.6954 13.5397C38.6523 13.5163 38.6092 13.4929 38.5661 13.4695C38.5231 13.4461 38.48 13.4227 38.4369 13.3993L31.0271 9.37649C29.2609 8.41755 27.0674 9.06736 26.1085 10.8336C25.1495 12.5999 25.7993 14.7934 27.5656 15.7523C25.7993 14.7934 23.6059 15.4432 22.6469 17.2095C21.688 18.9758 22.3378 21.1692 24.1041 22.1282C22.3378 21.1692 20.1443 21.8191 19.1854 23.5853C18.2265 25.3516 18.8763 27.5451 20.6426 28.504L8.19242 21.7447C6.42614 20.7858 4.23267 21.4356 3.27373 23.2018C2.3148 24.9681 2.96461 27.1616 4.73089 28.1205L24.5908 38.9027C24.6339 38.9261 24.6769 38.9495 24.72 38.9729C24.7631 38.9963 24.8062 39.0197 24.8493 39.0431L29.2434 41.4287C32.9483 43.4401 37.7181 41.8463 39.8698 37.883L43.5185 31.1625" stroke="#000" stroke-width="4" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                  </div>
                </div>
              </div>
              -->
            </article>

            <article class="cancelBtn" *ngIf="getCanCancelRequest()">
              <app-sales-cancel-request></app-sales-cancel-request>
            </article>
          </div>
        </form>
      </div>
    </div>
  </div>
</section>


<!-- SMS MODAL -->
<p-dialog [(visible)]="visibleFirstSentCodeMessageModal" [modal]="true" [draggable]="false" [resizable]="false" [closable]="true" position="bottom">
  <div class="dialog">
    <div class="container">
      <div class="wrapper">
        <div class="dialog__info">
          <h2>Importante</h2>
          <p *ngIf="sentCode"><span [innerHTML]="messageOtpServiceFirstSend"></span> No lo elimines, lo necesitarás más adelante para finalizar el proceso.</p>
          <p *ngIf="!sentCode">Hemos tenido un problema para enviar el código. No hay problema. Puedes ir leyendo el contrato y lo reintentamos más adelente.</p>
        </div>

        <div class="dialog__footer">
          <button pButton pRipple label="Continuar" icon="pi pi-angle-right" iconPos="right" class="p-button-primary p-button-raised p-button-rounded p-button-spaced w-full" (click)="visibleFirstSentCodeMessageModal=false"></button>
        </div>
      </div>
    </div>
  </div>
</p-dialog>


<!-- SECOND SEND MODAL -->
<p-dialog [(visible)]="visibleRetriesSentCodeMessageModal" [modal]="true" [draggable]="false" [resizable]="false" [closable]="true" position="bottom">
  <div class="dialog">
    <div class="container">
      <div class="wrapper">
        <div class="dialog__info">
          <h2>Importante</h2>
          <p *ngIf="!sentCode">Hemos tenido un problema para enviar el código. Vuelva a intentarlo por favor.</p>
        </div>

        <div class="dialog__footer">
          <button pButton pRipple label="Reintentar" icon="pi pi-angle-right" iconPos="right" class="p-button-primary p-button-raised p-button-rounded p-button-spaced w-full" (click)="closeAllModals(); visibleSigningModal=true;"></button>
        </div>
      </div>
    </div>
  </div>
</p-dialog>


<!--ATENCIÓN MODAL-->
<p-dialog [(visible)]="visibleAttentionModal" [modal]="true" [draggable]="false" [resizable]="false" [closable]="true" position="bottom" (onHide)="closeAttentionModal()">
  <div class="dialog">
    <div class="container">
      <div class="wrapper">
        <div class="dialog__info">
          <h2>¡Atención!</h2>
          <p>Ten en cuenta que, si firmas el contrato pero no finalizas el proceso ingresando el destino de desembolso deberás realizar una nueva solicitud.</p>
        </div>

        <div class="dialog__footer">
          <button pButton pRipple label="Continuar" icon="pi pi-angle-right" iconPos="right" class="p-button-primary p-button-raised p-button-rounded p-button-spaced w-full" (click)="closeAttentionModal()"></button>
        </div>
      </div>
    </div>
  </div>
</p-dialog>


<!-- AUTORIZACIÓN MODAL -->
<p-dialog [(visible)]="visibleSigningModal" [modal]="true" [draggable]="false" [resizable]="false" [closable]="true" position="bottom">
  <div class="dialog">
    <div class="container">
      <div class="wrapper">
        <div class="dialog__info pb-40">
          <h2>Confirmación</h2>
          <p>Ingresá el código de <strong>4 dígitos</strong> que recibirás por SMS y confirma tu firma digital presionando el boton <strong>"Firmar"</strong>.</p>
        </div>

        <div class="dialog__form">
          <form [formGroup]="form" (ngSubmit)="signing()" class="form">
            <div class="dialog__content">
              <div class="form__group form__group--codeNumber mb-40" [ngClass]="{'form__error': submitted && f['code'].errors}">
                <input pInputText type="text" formControlName="code" maxlength="4">

                <span class="form__msgError form__msgError--center" *ngIf="submitted && f['code'].errors">
                  <small class="p-error" *ngIf="f['code'].getError('required')">El código es requerido</small>
                  <small class="p-error" *ngIf="f['code'].getError('invalid')">El código es inválido</small>
                </span>

                <span class="form__msgValidate form__msgValidate--center" *ngIf="f['code'].pending">
                  <small class="p-validate">
                    <i class="pi pi-spin pi-spinner"></i>
                    <span>Validando código...</span>
                  </small>
                </span>
              </div>

              <div class="form__group mb-10" [ngClass]="{'form__error': submitted && f['acept_conditions'].errors}">
                <div class="form__checkbox">
                  <div class="form__checkboxItem form__checkboxItem--center">
                    <p-checkbox [binary]="true" inputId="contractSignature" formControlName="acept_conditions"></p-checkbox>
                    <label class="small" for="contractSignature">{{ 'He leído y firmo digitalmente el contrato de crédito.' | termReplace }}</label>
                  </div>
                </div>

                <span class="form__msgError form__msgError--center" *ngIf="submitted && f['acept_conditions'].errors">
                  <small class="p-error" *ngIf="f['acept_conditions'].getError('required')">Debes aceptar para continuar</small>
                </span>
              </div>
            </div>

            <div class="dialog__footer pb-15">
              <button pButton pRipple type="submit" label="Firmar" icon="pi pi-pencil" iconPos="right" class="p-button-primary p-button-raised p-button-rounded p-button-spaced w-full" [loading]="loading" [disabled]="form.invalid"></button>
            </div>

            <div class="dialog__ref">
              <div class="retrySend">
                <div class="retrySend__text">
                  <p *ngIf="sentCode">Si no ves el correo, revisá tu carpeta de spam. Si aún así no lo recibiste, podrás volver a intentarlo una vez transcurrido el tiempo indicado:</p>
                  <p *ngIf="!sentCode">Vamos a esperar un poco más. Una vez transcurrido el tiempo, podrás intentarlo nuevamente presionando el botón "Reenviar código"</p>
                </div>

                <div class="retrySend__time" *ngIf="timeNewCodeSending && !(timeNewCodeSending.minutes==0 && timeNewCodeSending.seconds==0)">
                  <p>Tiempo para el próximo reintento: {{ timeNewCodeSending.minutes }}:{{ timeNewCodeSending.seconds < 10 ? '0' + timeNewCodeSending.seconds : timeNewCodeSending.seconds }} min.</p>
                </div>

                <div class="retrySend__btns" *ngIf="timeNewCodeSending && timeNewCodeSending.minutes==0 && timeNewCodeSending.seconds==0">
                  <div class="retrySend__btn">
                    <p-button styleClass="blue" label="Reenviar código" icon="pi pi-sync pi-small" iconPos="right" [text]="true" [plain]="true" (click)="showOptionesSend()" [loading]="loading"></p-button>
                  </div>

                  <div class="retrySend__btn" *ngIf="isNotKredicashFlow() && vieValidateButtonWithDocument()">
                    <div class="separator"><span>O</span></div>

                    <p-button styleClass="blue" label="Realizar validación con el documento" icon="pi pi-id-card pi-big" iconPos="right" [text]="true" [plain]="true" (click)="showModal()"></p-button>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</p-dialog>


<!-- INGRESAR DOCUMENTO MODAL -->
<p-dialog [(visible)]="visibleCodeModal" [modal]="true" [draggable]="false" [resizable]="false" [closable]="true" position="bottom">
  <div class="dialog">
    <div class="container">
      <div class="wrapper">
        <div class="dialog__info pb-30">
          <h2>Validación con documento</h2>
          <p>Si no has recibido el código aún, te invitamos a introducir el <strong>documento de identidad</strong> del cliente.</p>
        </div>
        <div class="dialog__form">
          <form [formGroup]="formCode" (ngSubmit)="onSearchCode()" class="form">
            <div class="dialog__content">
              <div class="form__group" [ngClass]="{'form__error': (submitted || fc['document'].touched) && fc['document'].errors}">
                <label class="form__label pb-5" for="document">Ingresa tu número de documento *</label>
                <input pInputText id="document" type="text" formControlName="document">

                <span class="form__msgError" *ngIf="(submitted || fc['document'].touched) && fc['document'].errors">
                  <small class="p-error" *ngIf="fc['document'].getError('required')">{{ "El Documento" | required }}</small>
                </span>

                <span class="form__msgValidate" *ngIf="fc['document'].pending">
                  <small class="p-validate">
                    <i class="pi pi-spin pi-spinner"></i>
                    <span>Validando documento...</span>
                  </small>
                </span>
              </div>
            </div>

            <div class="dialog__footer">
              <button pButton pRipple type="submit" label="Buscar" icon="pi pi-search" iconPos="right" class="p-button-primary p-button-raised p-button-rounded p-button-spaced w-full" [loading]="loading" [disabled]="formCode.invalid"></button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</p-dialog>


<!-- ERROR DOCUMENTO MODAL-->
<p-dialog [(visible)]="visibleErrorIDModal" [modal]="true" [draggable]="false" [resizable]="false" [closable]="true" position="bottom">
  <div class="dialog">
    <div class="container">
      <div class="wrapper">
        <div class="dialog__icon">
          <div class="icon__state">
            <app-error-icon></app-error-icon>
          </div>
        </div>
        <div class="dialog__info dialog__info--error">
          <h2>No pudimos validar el documento</h2>
          <p>Verificá que los datos ingresados sean correctos e intentá nuevamente.</p>
          <p class="pt-20">Si el problema persiste, comunicate con soporte para ayudarte a resolverlo.</p>
        </div>

        <div class="dialog__footer">
          <button pButton pRipple label="Reintentar" icon="pi pi-angle-right" iconPos="right" class="p-button-primary p-button-raised p-button-rounded p-button-spaced w-full" (click)="onRetryID()"></button>
        </div>
      </div>
    </div>
  </div>
</p-dialog>


<!-- AUTORIZACIÓN MANUAL MODAL -->
<ng-container *ngIf="code">
  <p-dialog [(visible)]="visibleSigningManualModal" [modal]="true" [draggable]="false" [resizable]="false" [closable]="true" position="bottom">
    <div class="dialog">
      <div class="container">
        <div class="wrapper">
          <div class="dialog__info pb-20">
            <h2>Confirmación</h2>
            <p>Validamos tu número de documento y te asignamos un <strong>código de verificación</strong>:</p>
          </div>

          <div class="dialog__content pb-30">
            <div class="IDCodeContent">
              <div class="IDCode mb-15"><span>{{ code }}</span></div>
              <p>Por favor, <strong>ingresa</strong> a continuación el código de 4 dígitos anterior y confirma tu firma digital presionando el boton <strong>"Firmar"</strong></p>
            </div>
          </div>

          <div class="dialog__form">
            <form [formGroup]="form" (ngSubmit)="signing()" class="form">
              <div class="dialog__content">
                <div class="form__group form__group--codeNumber" [ngClass]="{'form__error': submitted && f['code'].errors}">
                  <input pInputText type="text" formControlName="code" maxlength="4">

                  <span class="form__msgError form__msgError--center" *ngIf="submitted && f['code'].errors">
                    <small class="p-error" *ngIf="f['code'].getError('required')">{{ "El Código" | required }}</small>
                    <small class="p-error" *ngIf="f['code'].getError('invalid')">{{ "El Código" | invalid }}</small>
                  </span>

                  <span class="form__msgValidate form__msgValidate--center" *ngIf="f['code'].pending">
                    <small class="p-validate">
                      <i class="pi pi-spin pi-spinner"></i>
                      <span>Validando código...</span>
                    </small>
                  </span>
                </div>

                <div class="form__group mb-10" [ngClass]="{'form__error': submitted && f['acept_conditions'].errors}">
                  <div class="form__checkbox">
                    <div class="form__checkboxItem form__checkboxItem--center">
                      <p-checkbox [binary]="true" inputId="contractSignatureManual" formControlName="acept_conditions"></p-checkbox>
                      <label class="small" for="contractSignatureManual">{{ 'He leído y firmo digitalmente el contrato de crédito.' | termReplace }}</label>
                    </div>
                  </div>

                  <span class="form__msgError form__msgError--center" *ngIf="submitted && f['acept_conditions'].errors">
                    <small class="p-error" *ngIf="f['acept_conditions'].getError('required')">Debes aceptar para continuar</small>
                  </span>
                </div>
              </div>

              <div class="dialog__footer pb-15">
                <button pButton pRipple type="submit" label="Firmar" icon="pi pi-pencil" iconPos="right" class="p-button-primary p-button-raised p-button-rounded p-button-spaced w-full" [loading]="loading" [disabled]="form.invalid"></button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </p-dialog>
</ng-container>


<!-- REENVIO DE CÓDIGO MODAL -->
<p-dialog [(visible)]="showOtpServiceModal" [modal]="true" [draggable]="false" [resizable]="false" [closable]="true" position="bottom">
  <div class="dialog">
    <div class="container">
      <div class="wrapper">
        <div class="dialog__info pb-30">
          <h2>Reenvío del codigo</h2>
          <p>En caso de no poder recibir el <strong>codigo</strong> con el método seleccionado, puede elegir otra opción de envío:</p>
        </div>

        <div class="dialog__form pb-20">
          <div class="form__radio form__radio--center">
            <div class="form__radioItem" *ngFor="let option of otpServicesOptions">
              <p-radioButton [inputId]="option.value" name="phoneType" [value]="option.value" [(ngModel)]="selectedOtpService"></p-radioButton>
              <label [for]="option.value">{{ option.label }}</label>
            </div>
          </div>
        </div>

        <div class="dialog__footer">
          <button pButton pRipple label="Reenviar" icon="pi pi-refresh" iconPos="right" class="p-button-primary p-button-raised p-button-rounded p-button-spaced w-full" [disabled]="!selectedOtpService" (click)="onSelectedOtpServiceAndSend(true)"></button>
        </div>
      </div>
    </div>
  </div>
</p-dialog>
